import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { IconButton, Tooltip } from "@mui/material";
export interface ImageViewActionProps {
    onView: () => void;
}
export const ImageViewAction = ({ onView }: ImageViewActionProps) => {
    return (
        <Tooltip title="Image preview">
            <IconButton onClick={onView}>
                <FontAwesomeIcon icon={MirageTheme.icons.image} style={MirageTheme.icons.sizeS} />
            </IconButton>
        </Tooltip>
    );
};
